<div id="tituloImpressao">
  <picture class="p-0 noprint">
    <source media="(min-width:767.98px)" srcset="./assets/images/logo-emerj-branca.png" style="width:80px;height:81px;">
    <img src="./assets/images/logo-emerj-branca.png" alt="Logo" style="width:80px;height:81px;">
  </picture>
  <div class="textoLogoImpressao h4">
    Escola de Magistratura do Estado do Rio de Janeiro
  </div>
</div>

<nav class="navbar sticky-top flex-md-nowrap p-3 shadow nav-header-color navbar-light noprint" auto-contraste>
  <div class="d-inline-block" id="divTopo">
      <img src="./assets/images/logo-emerj-branca.png" 
           alt="Logo" 
           title="Imagem Logo EMERJ">
    <span class="textoLogo">
      Escola de Magistratura do Estado do Rio de Janeiro
    </span>
  </div>
</nav>

<div class="container mt-0 mb-0">
  <div class="row">
    <!-- <div class="col-sm-0"></div> -->
    <div class="col-sm-12 p-0 ">
      <div class="pt-2 pb-0 mb-0">
        <label id="lblAmbiente" class="d-block text-center h5 mb-1 text-danger fw-bold"
              *ngIf="descricaoAmbienteApi != 'PRODUCAO'">
          {{descricaoAmbienteApi}}
        </label>
        <label id="lblDescConc" class="d-block text-center h5 mb-1">{{descricaoConcurso}}</label>
        <label id="lblPrazoConc"  class="d-block text-center h6 mb-1">{{descricaoPrazoConcurso}}</label>
        <div class="text-center">
        <!-- <button class="btn btn-primary btn-sm text-center azulTopo" 
                *ngIf="ind_PrazoConcurso=='NAO INICIADA' || ind_PrazoConcurso=='ENCERRADA' || ind_PrazoConcurso=='NAO_LIBERA'"
                (click)="btnOk()">
          <i class="fa fa-check">&nbsp;Ok</i>
        </button> -->
        </div>
      </div>
    </div>
    <!-- <div class="col-sm-0"></div> -->
  </div>
</div>
